<template>
    <header>
        <nav class="navbar navbar-expand-lg navbar-dark bg-black d-md-none">
            <div class="container-fluid">
                <router-link :to="{ name: 'home' }" class="navbar-brand">
                    <img
                        src="/img/logo-renault-white.svg"
                        class=""
                        width="50"
                    />
                </router-link>
                <h2 class="h4 mb-0 text-white me-auto">SALA DE PRENSA</h2>
                <label
                    class="burga-renault"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarRenault"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    for="check"
                >
                    <input type="checkbox" id="check" />
                    <span></span>
                    <span></span>
                    <span></span>
                </label>
                <div class="collapse navbar-collapse" id="navbarRenault">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.name == 'home' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{ name: 'home', params: { savePosition: true } }"
                            >
                                ÚLTIMAS NOTICIAS
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'argentina' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'argentina', savePosition: true },
                                }"
                            >
                                ARGENTINA
                            </router-link>
                        </li>
<!--                         <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'producto' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'producto', savePosition: true },
                                }"
                            >
                                PRODUCTO
                            </router-link>
                        </li> -->
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'corporativo' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'corporativo', savePosition: true },
                                }"
                            >
                                CORPORATIVO
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                data-toggle="collapse"
                                :class="$route.params.slug == 'sustentabilidad' ? 'active' : ''"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'sustentabilidad', savePosition: true },
                                }"
                            >
                                SUSTENTABILIDAD
                            </router-link>
                        </li>
                        <li class="nav-item dropdown">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug && $route.params.slug.startsWith('competicion') ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'competicion', savePosition: true },
                                }"
                            >
                                COMPETICIÓN
                            </router-link>
                            <ul class="dropdown-menu">
                                <li>
                                    <router-link
                                        class="nav-link"
                                        data-toggle="collapse"
                                        :to="{
                                            name: 'posts',
                                            params: { slug: 'competicion-local', savePosition: true },
                                        }"
                                    >
                                        LOCAL
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        data-toggle="collapse"
                                        :to="{
                                            name: 'posts',
                                            params: { slug: 'competicion-internacional', savePosition: true },
                                        }"
                                    >
                                        INTERNACIONAL
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <ul class="p-0 mt-5">
                            <li class="list-unstyled">
                                <a
                                    class="nav-link h5 text-white mb-3 fw-600"
                                    href="https://www.renault.com.ar/"
                                    target="_blank"
                                    >RENAULT.COM.AR</a
                                >
                            </li>
                        </ul>
                        <ul class="d-flex justify-content-center p-0">
                            <li class="icon-flex">
                                <a
                                    href="http://www.facebook.com/RenaultArgentina"
                                    target="_blank"
                                    class="text-decoration-none icon-wrapper"
                                >
                                    <i class="fab fa-facebook-f"></i>
                                </a>
                            </li>
                            <li class="icon-flex">
                                <a
                                    href="http://twitter.com/RenaultArg"
                                    target="_blank"
                                    class="text-decoration-none icon-wrapper"
                                >
                                    <i class="fab fa-twitter"></i>
                                </a>
                            </li>
                            <li class="icon-flex">
                                <a
                                    href="https://www.instagram.com/renaultarg/?hl=es"
                                    target="_blank"
                                    class="text-decoration-none icon-wrapper"
                                >
                                    <i class="fab fa-instagram"></i>
                                </a>
                            </li>
                            <li class="icon-flex">
                                <a
                                    href="http://www.youtube.com/user/RenaultArg"
                                    target="_blank"
                                    class="text-decoration-none icon-wrapper"
                                >
                                    <i class="fab fa-youtube"></i>
                                </a>
                            </li>
                            <li class="icon-flex">
                                <a
                                    href="https://www.linkedin.com/company/renault/"
                                    target="_blank"
                                    class="text-decoration-none icon-wrapper"
                                >
                                    <i class="fab fa-linkedin"></i>
                                </a>
                            </li>
                        </ul>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="container-fluid d-md-none bg-black">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 py-2">
                    <h1 class="text-white fw-600">ÚLTIMAS NOTICIAS</h1>
                </div>
            </div>
        </div>
        <div class="container-fluid bg-black d-none d-md-flex align-items-center p-3">
            <router-link :to="{ name: 'home' }" aria-label="Ir al Inicio">
                <img
                    src="/img/logo-renault-white.svg"
                    height="100"
                    alt="Logo Renault"
                />
            </router-link>
            <div class="container-fluid">
                <div class="row align-items-center text-white py-2">
                    <div class="col-5 col-xxl-3">
                        <h1 class="h3 mb-0 fw-600">RENAULT ARGENTINA</h1>
                        <h2 class="h4 mb-0">SALA DE PRENSA</h2>
                    </div>
                    <div class="ms-auto w-auto">
                        <ScrollLink href="#footer" class="text-decoration-none">
                            <button
                                type="button"
                                class="btn btn-renault btn-campana d-block px-4 mx-auto"
                            >
                                alertas.suscribirme
                            </button>
                        </ScrollLink>
                        <a
                            href="https://www.renault.com.ar/"
                            target="_blank"
                            type="button"
                            class="btn btn-link text-reset text-decoration-none"
                            >RENAULT.COM.AR</a
                        >
                        <span>|</span>
                        <button
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#contactoModal"
                            class="btn btn-link text-reset text-decoration-none"
                        >
                            CONTACTO
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <nav
            v-if="$route.name !== 'post'"
            class="navbar navbar-expand-lg navbar-light mt-2 mb-5 d-none d-md-block"
        >
            <div class="container-fluid justify-content-center">
                <div class="" id="navbarRenaultDesk">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.name == 'home' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{ name: 'home', params: { savePosition: true } }"
                            >
                                ÚLTIMAS NOTICIAS
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'argentina' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'argentina', savePosition: true },
                                }"
                            >
                                ARGENTINA
                            </router-link>
                        </li>
<!--                         <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'producto' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'producto', savePosition: true },
                                }"
                            >
                                PRODUCTO
                            </router-link>
                        </li> -->
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'corporativo' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'corporativo', savePosition: true },
                                }"
                            >
                                CORPORATIVO
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug == 'sustentabilidad' ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'sustentabilidad', savePosition: true },
                                }"
                            >
                                SUSTENTABILIDAD
                            </router-link>
                        </li>
                        <li class="nav-item dropdown">
                            <router-link
                                class="nav-link nav-link-renault"
                                :class="$route.params.slug && $route.params.slug.startsWith('competicion') ? 'active' : ''"
                                data-toggle="collapse"
                                :to="{
                                    name: 'posts',
                                    params: { slug: 'competicion', savePosition: true },
                                }"
                            >
                                COMPETICIÓN
                            </router-link>
                            <ul class="dropdown-menu">
                                <li>
                                    <router-link
                                        class="nav-link"
                                        data-toggle="collapse"
                                        :to="{
                                            name: 'posts',
                                            params: { slug: 'competicion-local', savePosition: true },
                                        }"
                                    >
                                        LOCAL
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        data-toggle="collapse"
                                        :to="{
                                            name: 'posts',
                                            params: { slug: 'competicion-internacional', savePosition: true },
                                        }"
                                    >
                                        INTERNACIONAL
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    mounted() {

    },
};
</script>
